import { render, staticRenderFns } from "./CardProducts.vue?vue&type=template&id=5669e9f7"
import script from "./CardProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./CardProducts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports